import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {TaskService} from '../../services/task.service';
import { NzInputDirective} from 'ng-zorro-antd/input';
import { NzMessageService} from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import {Subscription} from 'rxjs';
import {UtilsModule} from '../../utils/utils.module';
@Component({
  selector: 'nf-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.css']
})
export class ArchiveComponent implements OnInit, OnDestroy {
  dataSubscription: Subscription = null;
  boardId: string;
  boardData: any = {};
  boardDataOrigin = {};
  boardName: string;
  boardColumn: any = [];
  pageIndex = 1;
  pageSize = 10;
  total = 0;
  queryKeyword = '';
  loading = false;
  tableData: Array<any> = [];
  isBlank = true;
  labelData = [];
  groupData = [];
  labelList = [];
  index: number;
  showLabel = false;
  archivePulseList = [];
  @Output() linkChange: EventEmitter<any> = new EventEmitter();
  @Input('boardId') set changeId(data: any) {
    this.boardId = data;
    if (data) {
      this.taskService.getBoardData(this.boardId).subscribe(res => {
        this.boardDataOrigin = res;
      });
    } else {
      this.message.error('未知错误，无法获取面板数据!');
    }
    this.getRecycleList();
  }
  @Input('boardName') set changeName(data: any) {
    this.boardName = data;
  }
  linkType = 'board'; // 面板
  viewVisible = false;
  viewModalWidth = 1000;
  constructor(
    private activateInfo: ActivatedRoute,
    private taskService: TaskService,
    private message: NzMessageService,
    private utilsModule: UtilsModule,
  ) { }

  ngOnInit() {
    this.viewModalWidth = window.innerWidth * 0.9;
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  // 请求归档列表数据
  getRecycleList() {
    this.loading = true;
    const param = {
      'boardId': this.boardId,
      'page': this.pageIndex,
      'size': this.pageSize,
      'search': this.queryKeyword,
      'recycleBinMode': 'archived_board_object'
    };
    this.taskService.queryGroupRecycleWithLabel(param).subscribe((res) => {
      this.loading = false;
      this.labelData = [];
      this.labelList = [];
      if (res) {
        const label = Object.keys(res);
        // 如果只有一个且是 无
        if (label.length === 0 || (label.length === 1 && label[0] === '其他')) {
          this.showLabel = false;
        } else {
          this.showLabel = true;
        }
        this.labelData = res;
        label.forEach(key => {
          this.labelList.push({name: key, color: this.getAvatarColor()});
        });
        this.changeLabel(label[0]);
      }
    });
    // this.dataSubscription = this.taskService.getRecycleData(param).subscribe((res: any) => {
    //   const listData = res;
    //   this.loading = false;
    //   if (listData) {
    //     this.tableData = listData.data;
    //     this.total = listData.page.totalElements;
    //     this.pageIndex = listData.page.number;
    //     this.isBlank = !this.tableData || this.tableData.length === 0;
    //   }
    // }, (err: any) => {
    //   this.loading = false;
    // });
  }
  // 改变分页请求
  changePageIndex(num: number) {
    this.pageIndex = num;
    this.getRecycleList();
  }
  // 改变分页大小请求
  changePageSize(num: number) {
    this.pageSize = num;
    this.getRecycleList();
  }
  // 恢复
  doRestoreRecycle(type, id) {
    this.dataSubscription = this.taskService.restoreRecycleNew(type, id).subscribe((res: any) => {
      this.message.create('success', '已恢复!');
      this.getRecycleList();
    });
  }
  // 查看任务详情
  viewArchiveDetail(item, type?) {
   const param = {
      status: 'archived'
    };
     this.dataSubscription = this.taskService.getGroupData(item.boardId, item.groupId, param).subscribe(res => {
        if (res) {
          this.boardData = JSON.parse(JSON.stringify(this.boardDataOrigin));
          this.boardData.boardData.pulses = res['pulses'] ? res['pulses'] : [];
          this.boardData.boardData.groups = [];
          this.boardData.boardData.groups.push(res);
          this.boardData.boardData.currentUser.permissions = ['viewer'];
          if (!type) {
            this.viewVisible = true;
          } else if (type === 'list') {
            this.archivePulseList = this.boardData.boardData.pulses;
          }
        } else {
          this.message.info('该分组下没有数据!');
        }
      });
  }
  // 切换到归档面板
  changeLinkStatus() {
    this.linkChange.emit(this.linkType);
  }

  // 切换标签查看分组
  changeLabel(val: string) {
    this.groupData = [];
    if (val) {
      this.groupData =  JSON.parse(JSON.stringify(this.labelData[val]));
      // this.groupData.forEach(value => {
      //   if (value.recycleType && value.recycleType === 'group') {
      //     value.title = '分组 | ' + value.title;
      //   } else {
      //     value.title = '任务 | ' + value.title;
      //   }
      // });
    }
  }

  getAvatarColor() {
    return this.utilsModule.getRandomColor();
  }
  taskChange(event, item) {
    if (event) {
      this.archivePulseList = [];
      this.viewArchiveDetail(item, 'list');
    }
  }
}
